import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";


export const InitiateSync = createAsyncThunk(
    "initiateSync", async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.initiateSync, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const InitiateSyncSlice = createSlice({
    name: "initiateSync",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        initiateSyncReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [InitiateSync.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.data = payload;
            state.error = false;
        },
        [InitiateSync.pending]: (state) => {
            state.isLoading = true;
            state.data = false;
            state.error = null;
        },
        [InitiateSync.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        }
    }
})

export const { initiateSyncReset } = InitiateSyncSlice.actions;